/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable array-callback-return */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Roles } from '../../constants';
import EmptyScreen from '../../Components/GlobalEmplyPage';

function FilterModal({
    setfilter, threePL, territaryList, handleFiletr, selected, setselected, setRolesData, rolesData, managers,
}) {
    const [tab, settab] = useState('role');
    const [searchValue, setsearchValue] = useState('');
    const ItemPresent = (id, type, key) => {
        const arraycopy = [...selected[type]] || [];
        let index;
        if (key) {
            index = arraycopy.map((val) => val[key]).indexOf(id);
        } else {
            index = arraycopy.map((val) => val.ROLE_ID).indexOf(id);
        }

        return index > -1;
    };

    const AddToSelect = (item, type, key) => {
        const arr = [...selected[type]];
        let index;
        if (key) {
            index = arr.map((val) => val?.[key]).indexOf(item?.[key]);
        } else {
            index = arr.map((val) => val.ROLE_ID).indexOf(item.ROLE_ID);
        }
        if (index === -1) {
            arr.push(item);
        } else {
            arr.splice(index, 1);
        }
        setselected((prevState) => ({
            ...prevState,
            [type]: arr,
        }));
    };

    function removeLastComma(strng) {
        const n = strng.lastIndexOf(',');
        const a = strng.substring(0, n);
        return a;
    }
    const createUrl = (arr, key) => {
        let tempurl = '';
        if (key) {
            arr.forEach((val) => {
                tempurl += `${val[key]},`;
            });
            return encodeURIComponent(removeLastComma(tempurl));
        }
        arr.forEach((val) => {
            tempurl += `${val.ROLE_NAME},`;
        });
        return removeLastComma(tempurl.replace(/\s/g, '_').toLocaleLowerCase());
    };
    const generateUrl = (val) => {
        let final = '';
        Object.keys(selected).map((key) => {
            switch (key) {
            case 'role':
                if (selected[key].length > 0) {
                    final += `&roles=${createUrl(selected[key])}`;
                }
                break;
            case 'threpl':
                if (selected[key].length > 0) {
                    final += `&third_party_logistics=${createUrl(selected[key])}`;
                }
                break;
            case 'territory':
                if (selected[key].length > 0) {
                    final += `&territory=${createUrl(selected[key], 'NAME')}`;
                }
                break;
            case 'status':
                if (selected[key].length > 0) {
                    final += `&admin_status=${selected.status}`;
                }
                break;
            case 'reporting_managers':
                if (selected[key].length > 0) {
                    final += `&reporting_managers=${createUrl(selected[key], 'employee_code')}`;
                }
                break;
            default: break;
            }
        });
        if (val === undefined) {
            handleFiletr(final);
        }
        return final;
    };
    const normalizeString = (str) => str.toLowerCase();

    const filteredManagers = managers.length > 0 && managers.filter((manager) => {
        const fullName = `${manager?.first_name} ${manager?.last_name} (${manager?.employee_code})`;
        return normalizeString(fullName).includes(normalizeString(searchValue));
    });
    return (
        <div
            className="modal-dialog modal-dialog-centered relative max-w-[650px] pointer-events-none mt-0 mr-0 mb-0 h-full shadow-4xl bg-[#ffffff]"
        >
            <div
                className="modal-content border-none relative flex flex-col w-full pointer-events-auto bg-clip-padding outline-none text-current h-full"
            >
                <img
                    className="p-2 rounded-full cursor-pointer absolute top-4 right-4"
                    src="images/Component158–2.svg"
                    alt="close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setfilter(false)}
                />
                <div className="pt-[64px] pb-5 bg-[#ffffff]">
                    <div className="pl-[60px] sticky top-0 left-0 z-10 bg-[#FFFFFF]">
                        <div className="flex justify-between pr-5 items-center w-full">
                            <h2 className="text-xl font-bold text-[#555259]">
                                Filter (s)
                            </h2>
                            <div>
                                {(selected.role.length > 0 || selected.status || selected?.territory.length > 0 || selected?.reporting_managers?.length > 0) && (
                                    <p
                                        className="text-base text-[#555259] font-bold cursor-pointer pr-5"
                                        onClick={() => {
                                            setselected({
                                                role: [],
                                                threpl: [],
                                                territory: [],
                                                status: '',
                                                reporting_managers: [],
                                            });
                                        }}
                                    >
                                        Clear
                                        {' '}

                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="px-5 pt-6">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap list-none pl-0 -mr-2 pt-6  h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-center mb-3" role="presentation">
                                    <a href="javascript:void(0)" className={`nav-link block ${tab === 'role' ? 'active' : ''} text-base text-left font-normal text-[#555259] py-2.5 pl-[28px] pr-[28px]`} id="pills-home-tabVertical" data-bs-toggle="pill" data-bs-target="#pills-homeVertical" role="tab" aria-controls="pills-homeVertical" aria-selected={tab === 'role'} onClick={() => settab('role')}>Role</a>
                                </li>
                                {/* <li className="nav-item flex-grow text-center my-3" role="presentation">
                                    <a href="javascript:void(0)" className={`nav-link block ${tab === 'threepl' ? 'active' : ''} text-base font-normal text-[#555259] py-2.5 pl-[42px] pr-[63px]`} id="pills-profile-tabVertical" data-bs-toggle="pill" data-bs-target="#pills-profileVertical" role="tab" aria-controls="pills-profileVertical" aria-selected={tab === 'threepl'} onClick={() => settab('threepl')}>3PL</a>
                                </li>
                                <li className="nav-item flex-grow text-center my-3" role="presentation">
                                    <a href="javascript:void(0)" className={`nav-link block ${tab === 'territory' ? 'active' : ''} text-base font-normal text-[#555259] py-2.5 pl-[42px] pr-[63px]`} id="pills-contact-tabVertical" data-bs-toggle="pill" data-bs-target="#pills-contactVertical" role="tab" aria-controls="pills-contactVertical" aria-selected={tab === 'territory'} onClick={() => settab('territory')}>Territory</a>
                                </li> */}
                                <li className="nav-item flex-grow text-center my-3" role="presentation">
                                    <a href="javascript:void(0)" className={`nav-link block ${tab === 'status' ? 'active' : ''} text-base text-left font-normal text-[#555259] py-2.5 pl-[28px] pr-[28px]`} id="pills-status-tabVertical" data-bs-toggle="pill" data-bs-target="#pills-status" role="tab" aria-controls="pills-status" aria-selected={tab === 'status'} onClick={() => settab('status')}>Status</a>
                                </li>
                                <li className="nav-item flex-grow text-center my-3" role="presentation">
                                    <a href="javascript:void(0)" className={`nav-link block ${tab === 'territory' ? 'active' : ''} text-base text-left font-normal text-[#555259] py-2.5 pl-[28px] pr-[28px]`} id="pills-status-tabVertical" data-bs-toggle="pill" data-bs-target="#pills-status" role="tab" aria-controls="pills-status" aria-selected={tab === 'territory'} onClick={() => settab('territory')}>Territory</a>
                                </li>
                                <li className="nav-item flex-grow text-center my-3" role="presentation">
                                    <a href="javascript:void(0)" className={`nav-link block ${tab === 'reporting_manager' ? 'active' : ''} text-base text-left font-normal text-[#555259] py-2.5 pl-[28px] pr-[28px] whitespace-nowrap`} id="pills-status-tabVertical" data-bs-toggle="pill" data-bs-target="#pills-status" role="tab" aria-controls="pills-status" aria-selected={tab === 'reporting_manager'} onClick={() => settab('reporting_manager')}>Reporting Manager</a>
                                </li>
                            </ul>
                            <motion.div
                                animate={{ x: 15 }}
                                transition={{ delay: 1 }}
                                className="w-[1px] bg-[#D8D8D8] h-[500px]"
                            />
                            <div className="tab-content w-full" id="pills-tabContentVertical">
                                <motion.div
                                    animate={{ x: 20 }}
                                    transition={{ delay: 1 }}
                                >
                                    <div className={`relative tab-pane fade ${tab === 'role' ? 'show active' : 'hidden'}  h-[500px] w-full flex-1 py-7 px-4 bg-[#F5F5FA] rounded-lg overflow-auto more-list`} id="pills-homeVertical" role="tabpanel" aria-labelledby="pills-home-tabVertical">
                                        <div className="absolute top-3 right-7 pt-3">
                                            {selected.role.length === 0
                                                ? (
                                                    <p className="text-xs3 font-normal text-[#555259]">
                                                        0 Selected
                                                    </p>
                                                )

                                                : (
                                                    <p className="text-xs3 font-normal text-[#555259]">
                                                        {selected.role.length > 0 && selected.role.length}
                                                        {' '}
                                                        Selected
                                                    </p>
                                                ) }
                                        </div>
                                        {rolesData.length > 0 && rolesData.map((role) => (
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3" key={role.ROLE_ID}>
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-th${role.ROLE_ID}`}
                                                    checked={ItemPresent(role.ROLE_ID, 'role')}
                                                    onChange={() => AddToSelect(role, 'role')}
                                                />
                                                <label htmlFor={`checkbox-th${role.ROLE_ID}`} className="text-base font-normal cursor-pointer text-[#555259] pl-2">{role.ROLE_NAME}</label>
                                            </div>
                                        ))}
                                    </div>
                                </motion.div>
                                {/* <motion.div
                                    animate={{ x: 20 }}
                                    transition={{ delay: 1 }}
                                >
                                    <div className={`tab-pane fade h-[500px] ${tab === 'threepl' ? 'show active' : 'hidden'} w-full py-7 px-4 bg-[#F5F5FA] rounded-lg`} id="pills-profileVertical" role="tabpanel" aria-labelledby="pills-profile-tabVertical">
                                        {threePL && threePL.map((pl) => (
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3" key={pl.id}>
                                                <input type="checkbox" id={`checkbox-l1${pl.id}`} checked={ItemPresent(pl.id, 'threpl')} onChange={() => AddToSelect(pl, 'threpl')} />
                                                <label htmlFor={`checkbox-l1${pl.id}`} className="text-base font-normal text-[#555259] pl-2">{pl.label}</label>
                                            </div>
                                        ))}
                                    </div>
                                </motion.div> */}
                                {/* <motion.div
                                    animate={{ x: 20 }}
                                    transition={{ delay: 1 }}
                                >
                                    <div className={`tab-pane fade h-[500px] ${tab === 'territory' ? 'show active' : 'hidden'} w-full py-7 px-4 bg-[#F5F5FA] rounded-lg`} id="pills-contactVertical" role="tabpanel" aria-labelledby="pills-contact-tabVertical">
                                        {territaryList && territaryList.map((territory) => (
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3" key={territory.id}>
                                                <input type="checkbox" id={`checkbox-tt${territory.id}`} checked={ItemPresent(territory.id, 'territory')} onChange={() => AddToSelect(territory, 'territory')} />
                                                <label htmlFor={`checkbox-tt${territory.id}`} className="text-base font-normal text-[#555259] pl-2">{territory.label}</label>
                                            </div>
                                        ))}
                                    </div>
                                </motion.div> */}
                                <motion.div
                                    animate={{ x: 20 }}
                                    transition={{ delay: 1 }}
                                >
                                    <div className={`tab-pane fade  h-[500px] w-full py-7 ${tab === 'status' ? 'show active' : 'hidden'}  px-4 bg-[#F5F5FA] rounded-lg`} id="pills-status" role="tabpanel" aria-labelledby="pills-status-tabVertical">
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                            <input
                                                type="checkbox"
                                                id="checkbox-ac21"
                                                onChange={() => {
                                                    setselected((prevState) => ({
                                                        ...prevState,
                                                        // status: { active: selected.status.active === '1' ? '0' : '1', inactive: selected.status.inactive },
                                                        status: '1',
                                                    }));
                                                }}
                                                checked={selected.status === '1'}
                                                // checked={handleChecked('1')}
                                            />
                                            <label
                                                htmlFor="checkbox-ac21"
                                                className="text-base font-normal text-[#555259] pl-2"

                                            >
                                                Active

                                            </label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                            <input
                                                type="checkbox"
                                                id="checkbox-in11"
                                                checked={selected.status === '0'}
                                                // checked={handleChecked('1')}
                                                onChange={() => {
                                                    setselected((prevState) => ({
                                                        ...prevState,
                                                        // status: { inactive: selected.status.inactive === '1' ? '0' : '1', active: selected.status.active },
                                                        status: '0',
                                                    }));
                                                }}
                                            />
                                            <label
                                                htmlFor="checkbox-in11"
                                                className="text-base font-normal text-[#555259] pl-2"

                                            >
                                                Inactive

                                            </label>
                                        </div>
                                    </div>
                                </motion.div>

                                {/* territory filter starts here */}
                                <motion.div
                                    animate={{ x: 20 }}
                                    transition={{ delay: 1 }}
                                >
                                    <div className={`relative tab-pane fade h-[500px] overflow-auto more-list w-full py-7 ${tab === 'territory' ? 'show active' : 'hidden'}  px-4 bg-[#F5F5FA] rounded-lg`} id="pills-status" role="tabpanel" aria-labelledby="pills-status-tabVertical">
                                        <div className="absolute top-3 right-7 pt-3">
                                            {selected?.territory.length === 0
                                                ? (
                                                    <p className="text-xs3 font-normal text-[#555259]">
                                                        0 Selected
                                                    </p>
                                                )

                                                : (
                                                    <p className="text-xs3 font-normal text-[#555259]">
                                                        {selected.territory.length > 0 && selected.territory.length}
                                                        {' '}
                                                        Selected
                                                    </p>
                                                ) }
                                        </div>
                                        {territaryList?.length > 0 && territaryList.map((territory, i) => (
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3" key={territory?.ROLE_ID}>
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-th-${i}`}
                                                    checked={ItemPresent(territory?.NAME, 'territory', 'NAME')}
                                                    onChange={() => AddToSelect(territory, 'territory', 'NAME')}
                                                />
                                                <label htmlFor={`checkbox-th-${i}`} className="text-base font-normal cursor-pointer text-[#555259] pl-2">{territory?.NAME}</label>
                                            </div>
                                        ))}
                                    </div>
                                </motion.div>
                                {/* territory filter ends here */}

                                {/* reporting manager filter starts here */}
                                <motion.div
                                    animate={{ x: 20 }}
                                    transition={{ delay: 1 }}
                                >
                                    <div className={`relative tab-pane fade  w-full pb-7 ${tab === 'reporting_manager' ? 'show active' : 'hidden'}  pl-4 bg-[#F5F5FA] rounded-lg`} id="pills-status" role="tabpanel" aria-labelledby="pills-status-tabVertical">
                                        <div className="absolute top-0 right-10 pt-2">
                                            {selected?.reporting_managers.length === 0
                                                ? (
                                                    <p className="text-xs3 font-normal text-[#555259]">
                                                        0 Selected
                                                    </p>
                                                )

                                                : (
                                                    <p className="text-xs3 font-normal text-[#555259]">
                                                        {selected.reporting_managers.length > 0 && selected.reporting_managers.length}
                                                        {' '}
                                                        Selected
                                                    </p>
                                                ) }
                                        </div>
                                        <div className="sticky pt-7">
                                            <div className="relative mb-4">
                                                <label htmlFor="search" />
                                                <input
                                                    type="text"
                                                    name="search"
                                                    id="search"
                                                    autoComplete="off"
                                                    value={searchValue || ''}
                                                    onChange={(e) => {
                                                        setsearchValue((e.target.value));
                                                    }}
                                                    className="w-[210px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                                                    placeholder="Search"
                                                />
                                                <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                                            </div>
                                        </div>
                                        <div className="h-[395px] overflow-auto more-list">
                                            {filteredManagers?.length > 0 ? filteredManagers.map((manager, i) => (
                                                <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3" key={manager?.id}>
                                                    <input
                                                        type="checkbox"
                                                        id={`checkbox-th-manager-${i}`}
                                                        checked={ItemPresent(manager?.employee_code, 'reporting_managers', 'employee_code')}
                                                        onChange={() => AddToSelect(manager, 'reporting_managers', 'employee_code')}
                                                    />
                                                    <label htmlFor={`checkbox-th-manager-${i}`} className="text-base font-normal cursor-pointer text-[#555259] pl-2">{`${manager?.first_name} ${manager?.last_name} (${manager?.employee_code})`}</label>
                                                </div>
                                            ))
                                                : (
                                                    <div
                                                        className="flex flex-col h-full w-full text-justify items-center justify-center "
                                                    >
                                                        <img src="/images/Group8022.svg" alt="" />
                                                        <p className="text-center">
                                                            It seems there are
                                                            {' '}
                                                            <span className="text-[#ED1C24] mt-2 cursor-pointer ">
                                                                No reporting managers
                                                            </span>
                                                            {' '}
                                                            under the searched term.
                                                        </p>
                                                    </div>
                                                )}

                                        </div>
                                    </div>
                                </motion.div>
                                {/* territory filter ends here */}

                            </div>
                        </div>
                        <motion.div
                            animate={{ y: 20 }}
                            transition={{ delay: 1 }}
                            className="flex justify-end pt-5 pb-[60px] mr-[38px]"
                        >
                            <button
                                type="button"
                                onClick={() => generateUrl()}
                                className="text-lg font-semibold text-[#FFFFFF] h-[53px] w-[382px] rounded-[16px] bg-[#555259]"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                // disabled={generateUrl('check').length === 0}

                            >
                                Apply Filter(s)
                            </button>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
